module.exports = __webpack_public_path__ + "static/media/DiFelice-photo.09f494a2.PNG";